import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import * as React from "react";
import { Box, IconButton } from "@mui/material";
import { SearchValue } from "../../Redux/Action";
import { useDispatch, useSelector } from "react-redux";

const MobFilter = () => {
  const [showSearchBar, setshowSearchBar] = useState(false);
  // const [searchValue, setsearchValue] = useState("");
  const dispatch = useDispatch();
  const searchValue = useSelector((state) => state.searchvalue);

  useEffect(() => {
    changeshowSearchBar();
  }, [showSearchBar]);

  const changeshowSearchBar = () => {
    if (!showSearchBar) {
      dispatch(SearchValue(""));
    }
  };
  const handleSearchChange = (event) => {
    dispatch(SearchValue(event.target.value.toUpperCase()));
  };

  return (
    <Box>
      {!showSearchBar ? (
        <Box>
          <IconButton onClick={() => setshowSearchBar(!showSearchBar)}>
            <SearchIcon fontSize="large" />
          </IconButton>
        </Box>
      ) : (
        <Box>
          <TextField
            autoComplete="off"
            id="standard-basic"
            label="Search"
            variant="standard"
            value={searchValue}
            onChange={handleSearchChange}
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => setshowSearchBar(!showSearchBar)}
                  size="large"
                >
                  <ClearIcon />
                </IconButton>
              ),
            }}
            sx={{ width: "100%" }}
          />
        </Box>
      )}
    </Box>
  );
};
export default MobFilter;
